<template>
  <v-row class="mt-10">
    <v-col cols="8" offset="2">
      <v-alert
        text
        color="primary"
        type="info"
        prominent
      >
        <div class="ml-5 my-2">
          <h3 class="headline mb-2" v-text="$t('animation.title.noSession')" />
          <div v-text="$t('animation.message.noSession1')" />
          <div v-text="$t('animation.message.noSession2')" />
        </div>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NoOpenSessionContainer',
  computed: {
    ...mapGetters('animation', {
      openedSessionList: 'openedSessionList',
    }),
  },
  watch: {
    openedSessionList (newList, oldList) {
      // A l'ouverture d'au moins une première session
      if (newList.length && !oldList.length) {
        this.openFirstSession()
      }
    },
  },
  created () {
    if (this.openedSessionList.length) {
      this.openFirstSession()
    }
  },
  methods: {
    openFirstSession () {
      const firstSession = this.openedSessionList[0]
      this.$router.replace(`/animation/session/${firstSession.id}`)
    },
  },
}
</script>
